import { useCallback, useState } from "react";

export const useSlideshow = () => {
	const [isSlideshowOpened, setIsSlideshowOpened] = useState(false);
	const openSlideshow = useCallback(() => setIsSlideshowOpened(true), []);
	const closeSlideshow = useCallback(() => setIsSlideshowOpened(false), []);
	return { isSlideshowOpened, openSlideshow, closeSlideshow };
};
